import React from "react";
import "./Computation.css";
import { useState, useEffect } from "react";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import Cookies from "js-cookie";
import axios from "axios";
import { url } from "../../../../../../../../../App";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import excelIcon from "../../../../../../../../../assets/icons8-excel.svg";
import { useParams } from "react-router-dom";

const Computation = () => {
  const { loanid } = useParams();
  const mappedLoanId = loanid;
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const { borrowerData } = useBorrowerContext();
  console.log(borrowerData);
  const AllLoanDetails = borrowerData.loan;
  const [borrowerDetails, setBorrowerDetails] = useState({});
  const coApplicant = borrowerData.coapplicant;
  // const CPV = borrowerData.cpv;
  const [loanDetails, setLoanDetails] = useState({});
  const [CAMdetails, setCAMdetails] = useState({});
  console.log(CAMdetails);
  const [foir, setFoir] = useState(50);
  const [comment, setComment] = useState("");
  const [remarksState, setRemarksState] = useState({});
    const fetchLoanDetails = borrowerData.loan;
    const foundLoan = fetchLoanDetails.find((item) => item.loan_id === mappedLoanId);
    const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (mappedLoanId) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  useEffect(() => {
    const loan = AllLoanDetails.find((loan) => loan.loan_id === mappedLoanId);

    if (loan && loanDetails?.loan_id !== loan.loan_id) {
      setLoanDetails(loan);
    }

    FetchCAMdata();
    // eslint-disable-next-line
  }, [mappedLoanId, AllLoanDetails]);

  useEffect(() => {
    if (!mappedLoanId) return;

    axios
      .post(url + "/loan/getsingle", {
        token: token,
        email: email,
        loan_id: mappedLoanId,
      })
      .then((res) => {
        const data = res.data[0];
        if (data) {
          setLoanDetails(data);

          const initialState = {};
          data.reference_details?.forEach((ref, idx) => {
            initialState[idx] = ref.remark || "";
          });
          setRemarksState(initialState);
        }
      })
      .catch((err) => {
        console.error("Error fetching loan:", err);
      });

    FetchCAMdata();
    // eslint-disable-next-line
  }, [mappedLoanId]);

  console.log(loanDetails, "remarksState");

  useEffect(() => {
    if (borrowerData) {
      setBorrowerDetails(borrowerData.borrower || {});
    }
    // eslint-disable-next-line
  }, [borrowerData]);

  const handleSaveRemark = (reference, index) => {
    setRemark(reference, remarksState[index]);
  };

  async function FetchCAMdata() {
    try {
      const response = await axios.post(`${url}/cam/get/cam/data`, {
        token,
        email,
        loanId: mappedLoanId,
      });
      setCAMdetails(response.data);
      setFoir(response.data?.foir);
      setComment(response?.data?.comment);
    } catch (error) {
      console.error("Error fetching CAM data:", error);
    }
  }

  // function calculateMonthlyPayment(
  //   annualInterestRate,
  //   numberOfMonths,
  //   principal
  // ) {
  //   // Convert annual interest rate from percentage and to monthly interest rate
  //   const monthlyInterestRate = annualInterestRate / 12 / 100; // Divide by 100 to convert to decimal
  //   // PMT formula: P * r / (1 - (1 + r)^-n)
  //   const monthlyPayment =
  //     (principal * monthlyInterestRate) /
  //     (1 - Math.pow(1 + monthlyInterestRate, -numberOfMonths));
  //   return monthlyPayment.toFixed(2); // Rounded to two decimal places
  // }

  function CalculateObligation(
    obligationArray,
    obligationArrayCoApp1,
    obligationArrayCoApp2,
    obligationArrayCoApp3
  ) {
    // if (!Array.isArray(obligationArray)) return 0;

    // const filteredObligation = obligationArray.filter(obligation =>
    //   obligation.computeObligation === true ||
    //   obligation.computeObligation === "True" ||
    //   obligation.computeObligation === "true"
    // );
    // const totalEMI = filteredObligation.reduce((sum, currentEMI) => {
    //   const emiValue = parseInt(currentEMI?.emi, 10) || 0;
    //   return sum + emiValue;
    // }, 0);
    // console.log(totalEMI);
    // return totalEMI;

    let totalEMIfinal = 0;

    if (!Array.isArray(obligationArray)) {
      totalEMIfinal += 0;
    } else {
      const filteredObligation = obligationArray.filter(
        (obligation) =>
          obligation.computeObligation === true ||
          obligation.computeObligation === "True" ||
          obligation.computeObligation === "true"
      );

      const totalEMI = filteredObligation.reduce((sum, currentEMI) => {
        const emiValue = parseInt(currentEMI?.emi, 10) || 0;
        return sum + emiValue;
      }, 0);

      totalEMIfinal = totalEMIfinal + totalEMI;
    }

    if (!Array.isArray(obligationArrayCoApp1)) {
      totalEMIfinal += 0;
    } else {
      const filteredObligation = obligationArrayCoApp1.filter(
        (obligation) =>
          obligation.computeObligation === true ||
          obligation.computeObligation === "True" ||
          obligation.computeObligation === "true"
      );

      const totalEMI = filteredObligation.reduce((sum, currentEMI) => {
        const emiValue = parseInt(currentEMI?.emi, 10) || 0;
        return sum + emiValue;
      }, 0);

      totalEMIfinal = totalEMIfinal + totalEMI;
    }

    if (!Array.isArray(obligationArrayCoApp2)) {
      totalEMIfinal += 0;
    } else {
      const filteredObligation = obligationArrayCoApp2.filter(
        (obligation) =>
          obligation.computeObligation === true ||
          obligation.computeObligation === "True" ||
          obligation.computeObligation === "true"
      );

      const totalEMI = filteredObligation.reduce((sum, currentEMI) => {
        const emiValue = parseInt(currentEMI?.emi, 10) || 0;
        return sum + emiValue;
      }, 0);

      totalEMIfinal = totalEMIfinal + totalEMI;
    }

    if (!Array.isArray(obligationArrayCoApp3)) {
      totalEMIfinal += 0;
    } else {
      const filteredObligation = obligationArrayCoApp3.filter(
        (obligation) =>
          obligation.computeObligation === true ||
          obligation.computeObligation === "True" ||
          obligation.computeObligation === "true"
      );

      const totalEMI = filteredObligation.reduce((sum, currentEMI) => {
        const emiValue = parseInt(currentEMI?.emi, 10) || 0;
        return sum + emiValue;
      }, 0);

      totalEMIfinal = totalEMIfinal + totalEMI;
    }

    // console.log(totalEMI);
    // return totalEMI;
    return totalEMIfinal;
  }

  function calculateEligibleLoanAmount(E28, E14, E15) {
    // PMT function implementation
    function PMT(rate, nper, pv) {
      if (rate === 0) {
        return -pv / nper;
      }
      return -(pv * rate) / (1 - Math.pow(1 + rate, -nper));
    }

    const monthlyInterestRate = E14 / 100 / 12; // Convert annual rate to decimal and divide by 12
    const totalPayments = E15; // Number of monthly payments

    const payment = PMT(monthlyInterestRate, totalPayments, -1);
    const eligibleLoanAmount = E28 / payment;

    return eligibleLoanAmount;
  }

  function calculateFOIR(E31, E27, E24) {
    const result = (parseFloat(E31) + parseFloat(E27)) / parseFloat(E24);
    return (result * 100).toFixed(2);
  }

  async function AddComment() {
    const id = CAMdetails?._id;
    const responce = await axios.post(`${url}/cam/add/comment`, {
      token,
      email,
      id,
      comment,
    });
    toast.success(responce.data.message);
  }

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const setRemark = async (refrence, remark) => {
    try {
      const loanId = loanDetails?.loan_id;

      const updateRefrence = await axios.patch(`${url}/loan/addremarks`, {
        refrence,
        remark,
        loanId,
        email,
        token,
      });

      if (updateRefrence.data.auth) {
        const updatedReferences = loanDetails?.reference_details.map((ref) =>
          ref === refrence ? { ...ref, remark } : ref
        );

        setLoanDetails((prev) => ({
          ...prev,
          reference_details: updatedReferences,
        }));

        setRemarksState((prev) => ({
          ...prev,
          [loanDetails.reference_details.indexOf(refrence)]: remark,
        }));

        toast.success(updateRefrence.data.message);
      }
    } catch (error) {
      console.error(
        "Error updating remark:",
        error.response?.data || error.message
      );
    }
  };

  function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  function calculateMonthlyIncome(primaryIncome, secondaryIncome) {
    let finalSecondaryIncome = 0;
    secondaryIncome?.forEach((income) => {
      finalSecondaryIncome += Number(income?.finalIncome);
    });
    let totalMonthlyIncome = Number(primaryIncome) + finalSecondaryIncome;
    return parseFloat(totalMonthlyIncome).toFixed(2);
  }

  function calculateSecondaryIncome(secondaryIncomeArray) {
    let finalSecondaryIncome = 0;
    secondaryIncomeArray?.forEach((income) => {
      finalSecondaryIncome += Number(income?.finalIncome);
    });
    return finalSecondaryIncome;
  }

  async function handleGenerateExcelSheet() {
    try {
      const response = await axios.post(
        `${url}/cam/get/excel`,
        {
          token,
          email,
          loanId: mappedLoanId,
        }
        // {
        //   responseType: 'blob'
        // }
      );

      if (response.data.auth === true) {
        toast.success(response.data.message);

        FetchCAMdata();
      } else {
        toast.error(response.data.message);
      }

      // console.log("Response received:", response);

      // const blob = response.data;
      // const NEwurl = window.URL.createObjectURL(new Blob([blob]));
      // const link = document.createElement('a');
      // link.href = NEwurl;
      // link.setAttribute('download', 'Loan_Details.xlsx');
      // document.body.appendChild(link);
      // link.click();

      // document.body.removeChild(link);
      // window.URL.revokeObjectURL(NEwurl);
    } catch (err) {
      console.error("Error downloading file:", err);
      toast.error("Error Downloading File");
    }
  }

  const handleFoirValue = async (e) => {
    setFoir(e.target.value);

    try {
      const response = await axios.patch(`${url}/cam/update/foir`, {
        token,
        email,
        loanId: mappedLoanId,
        foirValue: e.target.value,
      });
      if (response.data.auth === true) {
        setCAMdetails(response.data);
        toast.success(response.data.message);

        const response1 = await axios.post(`${url}/cam/get/cam/data`, {
          token,
          email,
          loanId: mappedLoanId,
        });
        setCAMdetails(response1.data);
        setComment(response1?.data?.comment);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching CAM data:", error);
    }
  };

  const handleDownloadExcel = async (index) => {
    console.log(index);
    try {
      const file = await axios.post(`${url}/cam/download/excel`, {
        token,
        email,
        loanId: mappedLoanId,
        index: index,
      });

      if (file.data.auth === true) {
        let imgDoc = "image";
        let doc_type = "xlsx";

        const linkSource = `data:${imgDoc}/${doc_type};base64,${file.data.doc_base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${mappedLoanId}_CAM.${doc_type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

        toast.success("Excel file downloaded successfully");
      } else {
        toast.error("File not found");
      }
    } catch (err) {
      console.error("Error downloading file:", err);
      toast.error("Error Downloading File");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <div className="obligation-form-main-div">
      <hr className="hori-line" />
      {console.log("loan_professiontype-> ",loanDetails?.loan_professiontype)}
      <h2> {(loanDetails?.loan_professiontype==="SALARIED") ? "Credit Memo – Salaried" :" Credit Memo - Cattle " }</h2>

      <br></br>
      <br></br>

      {mappedLoanId && (
        <div className="obligation-form-mapped-loan-id-after-div">
          {/* <div style={{
            display: "flex",
            justifyContent: "space-between",
          }}>
            <div className="obligation-form-excel-downloading-div">
              <Button variant="contained" onClick={handleGenerateExcelSheet}
              >Download Excel</Button>
            </div>
          </div> */}

          {/* <br></br> */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              // gap: '50px'
            }}
          >
            {/* Borrower Detail Table */}
             {(loanDetails?.loan_professiontype!=="SALARIED") && (<div className="obligation-form-borrower-details-div">
              <h2>Deal Structure</h2>
              <div className="obligation-form-borrower-details-div-02">
                <table className="obligation-form-table">
                  <thead className="obligation-form-table-header">
                    <th className="obligation-form-table-th">
                      Animals to be Purchased
                    </th>
                    <th className="obligation-form-table-th">Cows</th>
                    <th className="obligation-form-table-th">Buffalos</th>
                  </thead>
                  <tbody>
                    <tr className="obligation-form-table-th">
                      <td className="obligation-form-table-th">
                        No of Animals to be Purchased
                      </td>
                      <td className="obligation-form-table-th">
                        {loanDetails?.number_of_cow}
                      </td>
                      <td className="obligation-form-table-th">
                        {loanDetails?.number_of_buffalo}
                      </td>
                    </tr>

                    <tr className="obligation-form-table-th">
                      <td className="obligation-form-table-th">
                        Price of Cattle
                      </td>
                      <td className="obligation-form-table-th">
                        {loanDetails?.price_of_cow}
                      </td>
                      <td className="obligation-form-table-th">
                        {loanDetails?.price_of_buffalo}
                      </td>
                    </tr>
                    <tr className="obligation-form-table-th">
                      <td className="obligation-form-table-th">
                        Loan Amount animalwise
                      </td>
                      <td className="obligation-form-table-th">
                        {loanDetails?.number_of_cow * loanDetails?.price_of_cow}
                      </td>
                      <td className="obligation-form-table-th">
                        {loanDetails?.number_of_buffalo *
                          loanDetails?.price_of_buffalo}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>)}
            

            {/* Proposed Loan Detail Table */}

            <div className="obligation-form-proposed-loan-div">
              <h2>Proposed / Appraised loan Details</h2>
              <div className="obligation-form-borrower-details-div-02">
                <table className="obligation-form-table">
                  <tr className="obligation-form-table-th">
                    <th className="obligation-form-table-th">Loan Amount</th>
                    <td className="obligation-form-table-th">
                      ₹
                      {/* {loanDetails?.number_of_cow * loanDetails?.price_of_cow +
                        loanDetails?.number_of_buffalo * loanDetails?.price_of_buffalo +
                        loanDetails?.loan_cattle_ins} */}
                      {loanDetails?.loan_principal_amt}
                    </td>
                    <th className="obligation-form-table-th">ROI</th>
                    <td className="obligation-form-table-th">
                      {loanDetails?.loanproduct_interest_rate * 12}%
                    </td>
                    <th className="obligation-form-table-th" rowSpan={2}>
                      EMI
                    </th>
                    <td className="obligation-form-data" rowSpan={2}>
                      ₹
                      {/* {calculateMonthlyPayment(
                        loanDetails?.loanproduct_interest_rate * 12,
                        loanDetails?.loan_duration,
                        loanDetails?.number_of_cow * loanDetails?.price_of_cow +
                        loanDetails?.number_of_buffalo *
                        loanDetails?.price_of_buffalo +
                        loanDetails?.loan_cattle_ins
                      )} */}
                      {loanDetails?.loan_emi_amt}
                    </td>
                  </tr>
                  <tr className="obligation-form-table-th">
                    <th className="obligation-form-table-th">
                      Insurance Amount
                    </th>
                    <td className="obligation-form-table-th">
                      ₹{loanDetails?.loan_cattle_ins}
                    </td>
                    <th className="obligation-form-table-th">Tenure</th>
                    <td className="obligation-form-table-th">
                      {loanDetails?.loan_duration}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <br></br>
          <br></br>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            {/* Deal Structure Table */}

            <div className="obligation-form-deal-structure-div">
              <h2>Borrower Details</h2>
              <div className="obligation-form-borrower-details-div-02">
                <table className="obligation-form-table">
                  <thead className="obligation-form-table-header">
                    <th className="obligation-form-table-th">Full Name</th>
                    <th className="obligation-form-table-th">Contact Number</th>
                    <th className="obligation-form-table-th">Relationship</th>
                    <th className="obligation-form-table-th">DOB</th>
                    <th className="obligation-form-table-th">Age</th>
                    <th className="obligation-form-table-th">Credit Score</th>
                  </thead>
                  <tr className="obligation-form-table-th">
                    <td className="obligation-form-table-th">
                      {borrowerDetails?.borrower_firstname}{" "}
                      {borrowerDetails?.borrower_lastname}
                    </td>
                    <td className="obligation-form-table-th">
                      {borrowerDetails?.borrower_mobile}
                    </td>
                    <td className="obligation-form-table-th">Self</td>
                    <td className="obligation-form-table-th">
                      {formatDate(borrowerDetails?.borrower_dob)}
                    </td>
                    <td className="obligation-form-table-th">
                      {" "}
                      {borrowerDetails?.borrower_dob &&
                        calculateAge(borrowerDetails?.borrower_dob)}
                    </td>
                    <td className="obligation-form-table-th">
                      {loanDetails?.credit_score &&
                      loanDetails?.credit_score !== "NA"
                        ? loanDetails?.credit_score
                        : CAMdetails?.borrower_bureau?.[0]?.cibilScore || "NA"}
                    </td>
                  </tr>
                  {coApplicant
                    ?.filter(
                      (singleCoapplicant) =>
                        singleCoapplicant?.coapplicant_loan_id === mappedLoanId
                    )
                    .map((singleCoapplicant, index) => {
                      const dbField = `coborrower_bureau_${index + 1}`;
                      const bureauScore =
                        CAMdetails?.[dbField]?.[0]?.cibilScore;

                      const displayScore =
                        singleCoapplicant.coapplicant_credit_score &&
                        singleCoapplicant.coapplicant_credit_score !== "NA"
                          ? singleCoapplicant.coapplicant_credit_score
                          : bureauScore || "NA";

                      return (
                        <tr
                          className="obligation-form-table-th"
                          key={singleCoapplicant._id}
                        >
                          <td className="obligation-form-table-th">
                            {singleCoapplicant.coapplicant_name}
                          </td>
                          <td className="obligation-form-table-th">
                            {singleCoapplicant.coapplicant_mobile}
                          </td>
                          <td className="obligation-form-table-th">
                            {singleCoapplicant.coapplicant_relationship}
                          </td>
                          <td className="obligation-form-table-th">
                            {formatDate(singleCoapplicant.coapplicant_dob)}
                          </td>
                          <td className="obligation-form-table-th">
                            {singleCoapplicant.coapplicant_dob &&
                              calculateAge(singleCoapplicant.coapplicant_dob)}
                          </td>
                          {/* <td className="obligation-form-table-th">{singleCoapplicant.coapplicant_credit_score}</td> */}
                          <td className="obligation-form-table-th">
                            {displayScore}
                          </td>
                        </tr>
                      );
                    })}
                </table>
              </div>
            </div>

            {/* Elegibility Table */}

            <div className="obligation-form-eligibilty-calculation-div">
              <h2>Eligibilty Calculation</h2>
              <div className="obligation-form-borrower-details-div-02">
                <table className="obligation-form-table">
                  <tbody>
                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">
                        Primary Income
                      </th>
                      <td className="obligation-form-table-th">
                        {CAMdetails?.finalPrimaryIncome}
                      </td>
                    </tr>
                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">
                        Secondary Income
                      </th>
                      <td className="obligation-form-table-th">
                        {calculateSecondaryIncome(
                          CAMdetails?.borrowerSecondaryIncome
                        )}
                      </td>
                    </tr>
                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">
                        Total Income (Monthly)
                      </th>
                      <td className="obligation-form-table-th">
                        {calculateMonthlyIncome(
                          CAMdetails?.finalPrimaryIncome,
                          CAMdetails?.borrowerSecondaryIncome,
                          CAMdetails?.borrower_obligation
                        )}
                      </td>
                    </tr>
                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">FOIR</th>
                      <td className="obligation-form-table-th">
                        <input
                          type="text"
                          className="input-text"
                          value={foir}
                          // onChange={(e) => setFoir(e.target.value)}
                          onChange={handleFoirValue}
                          disabled={isDisbursed}
                        ></input>
                      </td>
                    </tr>
                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">
                        MAXIMUM EMI AS PER FOIR
                      </th>
                      <td className="obligation-form-table-th">
                        {parseFloat(
                          calculateMonthlyIncome(
                            CAMdetails?.finalPrimaryIncome,
                            CAMdetails?.borrowerSecondaryIncome,
                            CAMdetails?.borrower_obligation
                          ) *
                            (foir / 100)
                        ).toFixed(2)}
                      </td>
                    </tr>

                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">Obligation</th>
                      <td className="obligation-form-table-th">
                        {CalculateObligation([
                          ...(CAMdetails?.borrower_obligation || []),
                          ...(CAMdetails?.coborrower_obligation_1 || []),
                          ...(CAMdetails?.coborrower_obligation_2 || []),
                          ...(CAMdetails?.coborrower_obligation_3 || []),
                        ])}
                      </td>
                    </tr>
                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">
                        Monthly Free Cash Flow
                      </th>
                      <td className="obligation-form-table-th">
                        {parseFloat(
                          (
                            calculateMonthlyIncome(
                              CAMdetails?.finalPrimaryIncome,
                              CAMdetails?.borrowerSecondaryIncome,
                              CAMdetails?.borrower_obligation
                            ) *
                              (foir / 100) -
                            CalculateObligation(
                              CAMdetails?.borrower_obligation,
                              CAMdetails?.coborrower_obligation_1,
                              CAMdetails?.coborrower_obligation_2,
                              CAMdetails?.coborrower_obligation_3
                            )
                          ).toFixed(2)
                        )}
                      </td>
                    </tr>

                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">
                        Eligible Loan Amount
                      </th>
                      <td className="obligation-form-table-th">
                        {calculateEligibleLoanAmount(
                          calculateMonthlyIncome(
                            CAMdetails?.finalPrimaryIncome,
                            CAMdetails?.borrowerSecondaryIncome,
                            CAMdetails?.borrower_obligation
                          ) *
                            (foir / 100) -
                            CalculateObligation(
                              CAMdetails?.borrower_obligation,
                              CAMdetails?.coborrower_obligation_1,
                              CAMdetails?.coborrower_obligation_2,
                              CAMdetails?.coborrower_obligation_3
                            ),
                          loanDetails?.loanproduct_interest_rate * 12,
                          loanDetails?.loan_duration
                        ).toFixed(2)}
                      </td>
                    </tr>

                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">
                        Proposed Loan Amount
                      </th>
                      <td className="obligation-form-table-th">
                        {/* {loanDetails?.number_of_cow * loanDetails?.price_of_cow +
                          loanDetails?.number_of_buffalo * loanDetails?.price_of_buffalo +
                          loanDetails?.loan_cattle_ins} */}
                        {loanDetails?.loan_principal_amt}
                      </td>
                    </tr>

                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">Proposed EMI</th>
                      <td className="obligation-form-table-th">
                        {/* {calculateMonthlyPayment(
                          loanDetails?.loanproduct_interest_rate * 12,
                          loanDetails?.loan_duration,
                          loanDetails?.number_of_cow * loanDetails?.price_of_cow +
                          loanDetails?.number_of_buffalo * loanDetails?.price_of_buffalo +
                          loanDetails?.loan_cattle_ins
                        )} */}
                        {loanDetails?.loan_emi_amt}
                      </td>
                    </tr>
                    <tr className="obligation-form-table-th">
                      <th className="obligation-form-table-th">FOIR</th>
                      <td className="obligation-form-table-th">
                        {calculateFOIR(
                          // calculateMonthlyPayment(
                          //   loanDetails?.loanproduct_interest_rate * 12,
                          //   loanDetails?.loan_duration,
                          //   loanDetails?.number_of_cow * loanDetails?.price_of_cow +
                          //   loanDetails?.number_of_buffalo * loanDetails?.price_of_buffalo +
                          //   loanDetails?.loan_cattle_ins
                          // ),
                          loanDetails?.loan_emi_amt,
                          CalculateObligation(
                            CAMdetails?.borrower_obligation,
                            CAMdetails?.coborrower_obligation_1,
                            CAMdetails?.coborrower_obligation_2,
                            CAMdetails?.coborrower_obligation_3
                          ),
                          calculateMonthlyIncome(
                            CAMdetails?.finalPrimaryIncome,
                            CAMdetails?.borrowerSecondaryIncome
                          )
                        )}
                        %
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <br></br>
          <br></br>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            {/* Reference Check Table */}

            <div className="obligation-form-refrence-check">
              <h2>Reference Check</h2>
              <div className="obligation-form-borrower-details-div-02">
                <table className="obligation-form-table">
                  <thead className="obligation-form-table-header">
                    <th className="obligation-form-table-th">Name</th>
                    <th className="obligation-form-table-th">Contact Number</th>
                    <th className="obligation-form-table-th">Relationship</th>
                    <th className="obligation-form-table-th">Remarks</th>
                  </thead>
                  {loanDetails?.reference_details?.map((reference, index) => (
                    <tr className="obligation-form-table-th" key={index}>
                      <td className="obligation-form-table-th">
                        {reference?.reference_name}
                      </td>
                      <td className="obligation-form-table-th">
                        {reference?.reference_number}
                      </td>
                      <td className="obligation-form-table-th">
                        {reference?.relationship_with_applicant}
                      </td>
                      <td>
                        <textarea
                          style={{
                            border: "none",
                            resize: "none",
                            outline: "none",
                            padding: "0",
                          }}
                          value={remarksState[index] || ""}
                          onChange={(e) => {
                            setRemarksState({
                              ...remarksState,
                              [index]: e.target.value,
                            });
                          }}
                          rows={4}
                          placeholder="Enter remark"
                          disabled={isDisbursed}
                        />

                        <button
                          style={{
                            cursor: "pointer",
                            background: "#1976d2",
                            borderRadius: "4px",
                            color: "#fff",
                          }}
                          onClick={() => handleSaveRemark(reference, index)}
                          disabled={isDisbursed}
                        >
                          Save
                        </button>
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>

            {/* Add Comment Table */}

            <div className="obligation-form-comment-div">
              <h2>Comment</h2>
              <div className="obligation-form-comment-div-01">
                <textarea
                  rows="10"
                  cols="70"
                  style={{ border: "1px solid black", resize: "none" }}
                  value={comment}
                  onChange={handleCommentChange}
                  disabled={isDisbursed}
                />
                <Button
                  onClick={AddComment}
                  variant="contained"
                  style={{ width: "50px", marginTop: "10px" }}
                  disabled={isDisbursed}
                >
                  ADD
                </Button>
              </div>
            </div>
          </div>
          <br></br>
          <br></br>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              // justifyContent: "space-between",
            }}
          >
            <div>
              <Button variant="contained" onClick={handleGenerateExcelSheet}>
                Generate Excel
              </Button>
            </div>
          </div>

          {/* Computation History Table */}

          {CAMdetails.computation_history && (
            <div className="computation-history-table-container">
              <h2>Computation History</h2>
              <div>
                <table className="computation-history-table">
                  <thead>
                    <th>Date</th>
                    <th>COMPUTED BY</th>
                    <th>Download</th>
                  </thead>
                  {CAMdetails?.computation_history?.map((history, index) => (
                    <tr key={index}>
                      <td>{history.date_time}</td>
                      <td>{history.generated_by}</td>
                      <td>
                        <img
                          src={excelIcon}
                          alt=""
                          title="Download file"
                          onClick={() => handleDownloadExcel(index)}
                          style={{ cursor: "pointer" }}
                        />
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Computation;
